import { pxToRem, themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.div `
  display: flex;
  align-items: center;
  flex-shrink: 0;
  height: ${pxToRem(72)};
  padding: ${themeGet('spacing.xl')};
  gap: ${themeGet('spacing.md')};
`;
export const AlignRight = styled.div `
  display: flex;
  gap: ${themeGet('spacing.md')};
  margin-left: auto;
`;
export const Spacer = styled.div `
  display: flex;
  align-items: center;
  gap: ${themeGet('spacing.sm')};
`;
